import { createContext, useState } from "react";

export const MainSidePanelContext = createContext();

const MainSidePanelProvider = ({ children }) => {
    const [isSidePanelOpen, setIsSidePanelOpen] = useState(true);
    const onOpenSidePanel = () => {
        setIsSidePanelOpen(true);
    };
    const onCloseSidePanel = () => {
        setIsSidePanelOpen(false);
    };

    return (
        <MainSidePanelContext.Provider value={{ isSidePanelOpen, onOpenSidePanel, onCloseSidePanel }}>
            {children}
        </MainSidePanelContext.Provider>
    );
};

export default MainSidePanelProvider;
